(() => {
  if (customElements.get('biz-deal-spotlight')) return;
  const engine = window.BizSpotlightEngine;
  if (!engine) return;
  const used = new Map();
  let seed = String(Math.random());
  if (window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() === true) {
    try { seed = sessionStorage.getItem('biz-spotlight-seed') || seed; sessionStorage.setItem('biz-spotlight-seed', seed); } catch {}
  }
  document.addEventListener('visitorConsentCollected', () => {
    if (window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() !== true) {
      try { sessionStorage.removeItem('biz-spotlight-seed'); } catch {}
    }
  });
  class DealSpotlight extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.turn = 0;
      this.time = Date.now();
      this.payloadNode = this.querySelector('[data-sp-payload]');
      try { this.data = JSON.parse(this.payloadNode.dataset.spPayload); } catch { return; }
      this.blocked = new Set();
      this.nextButton = this.querySelector('[data-sp-next]');
      this.onNext = () => { this.turn++; this.pick(true); };
      this.nextButton.addEventListener('click', this.onNext);
      this.onImageError = () => {
        if (!this.active) return;
        if (this.current) this.blocked.add(this.current.id);
        this.pick();
      };
      this.querySelector('[data-sp-image]').addEventListener('error', this.onImageError);
      const visibility = this.dataset.spVisibility;
      this.media = matchMedia(visibility === 'desktop' ? '(min-width: 992px)' : visibility === 'mobile' ? '(max-width: 991px)' : 'all');
      this.onMedia = () => {
        if (this.media.matches) {
          // Give the compact product placement its first eligible pick; broader banners
          // can then choose from the remaining department products without duplicates.
          if (!this.classList.contains('bj-live--glance') && document.querySelector('.bj-live--glance')) {
            queueMicrotask(() => { if (this.isConnected && this.media.matches) this.activate(); });
          } else this.activate();
        }
        else this.deactivate();
      };
      this.media.addEventListener('change', this.onMedia);
      this.onMedia();
      this.autoButton = this.querySelector('[data-sp-toggle]');
      if (this.autoButton) {
        this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.updateAuto = () => { this.autoButton.innerHTML = this.paused ? "<svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\" focusable=\"false\"><path d=\"m8 5 10 7-10 7Z\"/></svg>" : "<svg width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\" focusable=\"false\"><path d=\"M9 5v14M15 5v14\"/></svg>"; this.autoButton.setAttribute('aria-label', this.paused ? this.autoButton.dataset.spPlay : this.autoButton.dataset.spPause); };
        this.onToggle = () => { this.paused = !this.paused; this.updateAuto(); };
        this.autoButton.addEventListener('click', this.onToggle); this.updateAuto();
        this.autoTimer = setInterval(() => {
          const rect = this.getBoundingClientRect();
          if (!this.active || this.paused || document.hidden || this.matches(':hover,:focus-within') || rect.bottom <= 0 || rect.top >= innerHeight || this.nextButton.hidden) return;
          this.turn++; this.pick();
        }, 12000);
      }
    }
    activate() {
      if (this.active) return;
      this.active = true;
      this.pick();
      this.expiryTimer = setInterval(() => this.check(), 15000);
      this.refreshTimer = setInterval(() => this.refresh(), 300000);
      this.onVisible = () => { if (!document.hidden) { this.check(); if (Date.now() - this.lastRefresh > 300000) this.refresh(); } };
      document.addEventListener('visibilitychange', this.onVisible);
      this.lastRefresh = Date.now();
    }
    deactivate() {
      this.active = false;
      clearInterval(this.expiryTimer); clearInterval(this.refreshTimer);
      document.removeEventListener('visibilitychange', this.onVisible);
      this.hide();
    }
    disconnectedCallback() {
      if (this.data) this.deactivate();
      this.media?.removeEventListener('change', this.onMedia);
      this.nextButton?.removeEventListener('click', this.onNext);
      this.querySelector('[data-sp-image]')?.removeEventListener('error', this.onImageError);
      clearInterval(this.autoTimer);
      this.autoButton?.removeEventListener('click', this.onToggle);
      this.connected = false;
    }
    taken() { return new Set([...used.entries()].filter(([node]) => node !== this && node.active && node.media.matches).map(([, id]) => id).concat([...this.blocked])); }
    pick(announce = false) {
      if (!this.active) return;
      const item = engine.choose(this.data.items, this.data.config, Date.now(), this.taken(), seed, this.turn);
      const valid = item && engine.eligible(item, this.data.config, Date.now());
      if (!valid) { this.hide(); return; }
      this.render(valid);
      if (announce) this.querySelector('[data-sp-status]').textContent = this.data.labels.showing.replace('[title]', item.title);
    }
    hide() {
      this.current = null; used.delete(this);
      this.querySelector('[data-sp-card]').hidden = true;
      this.querySelector('[data-sp-notes]').hidden = true;
      const fallback = this.querySelector('[data-sp-fallback]'); if (fallback) fallback.hidden = false;
      const empty = this.querySelector('[data-sp-empty]'); if (empty) empty.hidden = Boolean(fallback);
      this.querySelectorAll('[data-sp-link]').forEach(a => a.removeAttribute('href'));
      this.querySelector('[data-sp-image]').removeAttribute('src');
      delete this.dataset.product;
    }
    render(item) {
      this.dataset.compactOffer = 'spotlight';
      this.dataset.snapshot = JSON.stringify(item.snapshot);
      this.dataset.conditionalOffers = JSON.stringify(item.conditional || null);
      this.dataset.productPath = item.url;
      this.current = item; used.set(this, item.id);
      const labels = this.data.labels, q = selector => this.querySelector(selector);
      const format = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
      this.querySelectorAll('[data-sp-link]').forEach(a => { a.setAttribute('href', item.url); a.setAttribute('aria-label', labels.view + ': ' + item.title); });
      q('[data-sp-title]').textContent = item.title;
      q('[data-sp-brand]').textContent = ['Amazon', item.brand].filter(Boolean).join(' · ');
      const sale = Boolean(item.reference > item.price && item.displayDiscount > 0);
      const [whole, cents] = (item.price / 100).toFixed(2).split('.');
      q('[data-sp-price] .bd-money').dataset.sale = String(sale);
      q('[data-money-full]').textContent = (sale ? labels.now + ' ' : '') + format(item.price);
      q('[data-money-now]').textContent = labels.now;
      q('[data-money-now]').hidden = !sale;
      q('[data-money-whole]').textContent = Number(whole).toLocaleString(document.documentElement.lang || 'en-US');
      q('[data-money-cents]').textContent = cents;
      q('[data-sp-saving]').hidden = !sale;
      q('[data-sp-saving-amount]').textContent = sale ? format(item.reference - item.price) : '';
      q('[data-sp-discount]').textContent = item.displayDiscount ? labels.off.replace('[percent]', item.displayDiscount) : '';
      q('[data-sp-discount]').hidden = !item.displayDiscount;
      q('[data-sp-reference]').hidden = !sale;
      q('[data-sp-old-price]').textContent = item.reference ? format(item.reference) : '';
      const ref = item.snapshot.reference;
      q('[data-sp-reference-label]').textContent = /typical/i.test(ref?.label || ref?.type || '') ? labels.typical : /list/i.test(ref?.label || ref?.type || '') ? labels.list : labels.reference;
      q('[data-sp-reference]').title = q('[data-sp-reference-label]').textContent;
      const badge = item.pricePending ? '' : item.prime ? labels.prime : item.snapshot.offerType === 'LIGHTNING_DEAL' ? labels.lightning : item.limited ? labels.limited : item.placement?.indicator?.kind === 'deal' ? labels.deal : '';
      q('[data-sp-badge-text]').textContent = badge;
      q('[data-sp-badge]').hidden = !badge;
      q('[data-sp-eligibility]').hidden = !item.prime;
      q('[data-sp-rank]').hidden = !item.rank;
      q('[data-sp-rank-text]').textContent = item.rank ? labels.rank.replace('[rank]', item.rank.rank).replace('[category]', item.rank.name) : '';
      const img = q('[data-sp-image]');
      if (img.getAttribute('src') !== item.image) img.src = item.image;
      img.alt = item.title;
      const option = item.option && !['Standard', 'Default Title'].includes(item.option) ? item.option : '';
      q('[data-sp-option]').textContent = option; q('[data-sp-option]').hidden = !option;
      q('[data-sp-updated]').textContent = labels.updated + ' ' + window.BizedealsTime.format(item.snapshot.fetchedAt);
      q('[data-sp-card]').hidden = false; q('[data-sp-notes]').hidden = false;
      const fallback = q('[data-sp-fallback]'); if (fallback) fallback.hidden = true;
      const empty = q('[data-sp-empty]'); if (empty) empty.hidden = true;
      q('[data-sp-offer]').hidden = Boolean(item.pricePending);
      q('[data-sp-price-pending]').hidden = !item.pricePending;
      q('[data-sp-notes]').hidden = Boolean(item.pricePending);
      q('.bz-spotlight__cta span').textContent = item.pricePending ? 'Check current price on Amazon' : labels.view;
      this.nextButton.hidden = engine.pool(this.data.items, this.data.config, Date.now(), this.taken()).length < 2;
      this.dataset.product = item.id;
    }
    check() {
      const valid = this.current && engine.eligible(this.current, this.data.config, Date.now());
      if (valid) { if(Boolean(valid.pricePending)!==Boolean(this.current.pricePending))this.render(valid); return; }
      this.time = Date.now(); this.pick();
    }
    async refresh() {
      if (!this.active || document.hidden || this.fetching || !this.isConnected) return;
      this.fetching = true;
      try {
        const url = new URL(location.href); url.searchParams.set('section_id', this.data.config.refreshSection || this.data.config.slot);
        const result = await fetch(url, { cache: 'no-store', signal: AbortSignal.timeout(12000) });
        if (!result.ok) return;
        const doc = new DOMParser().parseFromString(await result.text(), 'text/html');
        const next = [...doc.querySelectorAll('[data-sp-payload]')].map(node => {
          try { return JSON.parse(node.dataset.spPayload); } catch { return null; }
        }).find(value => value?.config.slot === this.data.config.slot);
        if (!this.active || !this.isConnected) return;
        if (!next) { this.data.items = []; this.hide(); return; }
        this.data = next; this.lastRefresh = Date.now();
        const old = this.current && next.items.find(item => item?.id === this.current.id);
        const valid = old && engine.eligible(old, next.config, Date.now());
        if (valid) this.render(valid); else { this.time = Date.now(); this.pick(); }
      } catch { this.check(); } finally { this.fetching = false; }
    }
  }
  customElements.define('biz-deal-spotlight', DealSpotlight);
})();

